import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import PreparationForTestingRequestForm from "./preparation-for-testing-request-form";
import { PreparationForTestingRequestFormState } from "@/types/brm";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "../../../common/buttons";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveTestingData, fetchRequestDetailed, setError, setValidationErrors, setWarning } from "../../../../reducers/administration/requestSlice";
import { AppDispatch, RootState } from "../../../../store";
import { EntityFormHeaderTitle } from "../../../common/entity-form";
import "./styles.less";
import { ErrorsDialog, ProgressDialog } from "../../../common/dialogs";
import ApproveRequestWithConflictsDialog from "../request-detailed-page/approve-request-with-conflicts-dialog";

const PreparationForTestingRequestFormPage = () => {
    const navigate = useNavigate();
    const intl = useIntl();
    const { requestId, source } = useParams();
    const dispatch = useDispatch<AppDispatch>();
    const validationErrors = useSelector((state: RootState) => state.administration.requests.validationErrors);
    const [formErrors, setFormErrors] = useState({});
    const error = useSelector((state: RootState) => state.administration.requests.error);
    const busy = useSelector((state: RootState) => state.administration.requests.busy);
    const warning = useSelector((state: RootState) => state.administration.requests.warning);
    const busyType = useSelector((state: RootState) => state.administration.requests.busyType);
    const [approveWithConflictsMessage, setApproveWithConflictsMessage] = useState("");
    const [form, setForm] = React.useState<PreparationForTestingRequestFormState>({
        testingResponsible: [],
        testingUserCount: "0",
        additionalRoles: [],
        testingDuration: "",
    });

    const handleCancelClick = () => {
        dispatch(setValidationErrors(null));
        navigate("..", { relative: "path" });
    };

    const handleSubmitClick = async () => {
        // if (!requestId || !form.testingUserCount) {
        //     setValidationErrors({ testingUserCount: { value: "", message: "Поле не может быть пустым" } });
        //     return;
        // }
        if (requestId) {
            const waringData = await dispatch(saveTestingData({ form, requestId, riskCheck: true }));

            if (waringData && waringData.payload){
                return
            }

            dispatch(fetchRequestDetailed({ requestId: requestId }));
            navigate(`/brm/${source}/request/${requestId}`);
        }
    };

    useEffect(() => {
        if (!validationErrors) return;

        const formErrosTmp = validationErrors.reduce((accumulator, error) => {
            accumulator[error.field] = error;

            return accumulator;
        }, {});

        setFormErrors(formErrosTmp);
    }, [validationErrors, form]);

    const handleApproveWithConflicts = async () => {
        if (requestId) {
            await dispatch(saveTestingData({ form, requestId, riskCheck: false, approveWithConflictsMessage })).unwrap();
            setApproveWithConflictsMessage("")
            dispatch(setError(null));
            dispatch(setWarning(null));
            dispatch(fetchRequestDetailed({ requestId: requestId }));
            navigate(`/brm/${source}/request/${requestId}`);
        }
    };

    return (
        <>
            <Box sx={{ backgroundColor: "#f5f5f5", padding: "15px 20px 15px" }}>
                <EntityFormHeaderTitle
                    title={intl.formatMessage({ id: "preparation-for-testing-request-form-page.title" })}
                    onBackClick={handleCancelClick}
                />
                <PreparationForTestingRequestForm form={form} setForm={(newData) => setForm((prev) => ({ ...prev, ...newData }))} validationErrors={formErrors} />
            </Box>
            <Box className="preparation-for-testing-request-form-page-buttons">
                <Button onClick={handleSubmitClick} className="preparation-for-testing-request-form-page-button-submit" variant="contained">
                    <FormattedMessage id="preparation-for-testing-request-form-page.btn-submit" />
                </Button>
                <Button onClick={handleCancelClick} className="preparation-for-testing-request-form-page-button-cancel" variant="outlined">
                    <FormattedMessage id="preparation-for-testing-request-form-page.btn-cancel" />
                </Button>
            </Box>
            <ErrorsDialog error={error} open={error?.type === "error" && error.code != "HAS RISKS"} onClose={() => dispatch(setError(null))} />
            <ApproveRequestWithConflictsDialog
                onSave={handleApproveWithConflicts}
                approveMessage={approveWithConflictsMessage}
                setApproveMessage={setApproveWithConflictsMessage}
                open={warning?.type === "warning" && warning?.code === "HAS_RISKS"}
                onClose={() => dispatch(setWarning(null))}
            />
            <ProgressDialog title={""} open={busy} busyType={busyType} progress={""} />
        </>
    );
};

export default PreparationForTestingRequestFormPage;
